import { capitalize } from 'lodash'
import React, { FC, useEffect } from 'react'
import { useDispatch } from 'react-redux'
import { RouteComponentProps } from 'react-router-dom'
import routes from 'src/routes'
import { setPageTitle, setPreviousPage } from '../../../ducks/onDemand'
import { ListItem } from '../AbstractList/ListItem'

const posters = [
  {
    id: 788,
    title: 'FROM OSTEOARTHRITIC SYNOVIUM TO SYNOVIAL-DERIVED CELLS CHARACTERIZATION: OBESE VS NON-OBESE',
    presenting_author_name: 'Chiaw-Lee Chiew',
  },
  {
    id: 439,
    title: 'METFORMIN IMPROVES EXTRACELLULAR MATRIX HOMEOSTASIS RELATED GENES AND TENOGENIC EXPRESSIONS ON INSULIN RESISTANCE INDUCED-HUMAN TENOCYTES IN VITRO',
    presenting_author_name: 'Tan Hui Yee',
  },
  {
    id: 853,
    title:
      'PERIVASCULAR STEM CELLS DEMONSTRATE SIMILAR LEVEL OF STEMNESS, CHONDROGENIC ABILITY AND OSTEOARTHRITIS REPAIR POTENTIAL TO MESENCHYMAL STROMAL CELLS',
    presenting_author_name: 'Shan Xiaolong',
  },
  {
    id: 860,
    title: 'RABBIT ARTICULAR CARTILAGE DEFECT TREATMENT USING THE COMBINED EFFECT OF BONE MARROW ASPIRATE CONCENTRATE AND PLATELET RICH PLASMA',
    presenting_author_name: 'Nabillah binti Abd Radzak',
  },
  {
    id: 880,
    title:
      'THE PROSPECTIVE ROLE OF DECELLULARISED HUMAN AMNIOTIC MEMBRANE INCORPORATED WITH PLATELET-RICH PLASMA IN MODERATING FIBROBLAST CHARACTERISTICS OF MESENCHYMAL STROMAL CELLS FOR ACUTE LARGE WOUND HEALING',
    presenting_author_name: 'AHMAD FUAD BIN AHMAD KAMAL',
  },
]

export const BestBasicScience: FC<RouteComponentProps> = () => {
  const dispatch = useDispatch()

  useEffect(() => {
    dispatch(setPageTitle('Best Basic Science Award'))
    dispatch(setPreviousPage(routes.onDemand))
  }, [dispatch])

  return (
    <div>
      {posters.map((poster) => {
        return <ListItem key={poster.id} abstractType="oral" title={poster.title} subtitle={capitalize(poster.presenting_author_name)} abstractId={poster.id} />
      })}
    </div>
  )
}
